import config from "@/config"
import http from "@/utils/request"

export default {
    getDeviceProperty: {
        url: `${config.API_URL}/JKD-420-4G-ONENET/deviceProperty/`,
        name: "查询JKD-420-4G-ONENET设备最新属性数据",
        get: async function (deviceNumber) {
            return await http.get(this.url + deviceNumber);
        },
    },
    vibSwitch: {
        url: `${config.API_URL}/JKD-420-4G-ONENET/service/vibSwitch/`,
        name: "JKD-420-4G-ONENET震动报警开关",
        post: async function (deviceNumber, data) {
            return await http.post(this.url + deviceNumber, data);
        },
    },
    sensitivity: {
        url: `${config.API_URL}/JKD-420-4G-ONENET/service/sensitivity/`,
        name: "JKD-420-4G-ONENET震动灵敏度",
        post: async function (deviceNumber, data) {
            return await http.post(this.url + deviceNumber, data);
        },
    },
    tiltSwitch: {
        url: `${config.API_URL}/JKD-420-4G-ONENET/service/tiltSwitch/`,
        name: "JKD-420-4G-ONENET倾斜报警开关",
        post: async function (deviceNumber, data) {
            return await http.post(this.url + deviceNumber, data);
        },
    },
    tiltAngle: {
        url: `${config.API_URL}/JKD-420-4G-ONENET/service/tiltAngle/`,
        name: "JKD-420-4G-ONENET倾斜报警角度",
        post: async function (deviceNumber, data) {
            return await http.post(this.url + deviceNumber, data);
        },
    },
    vibInterval: {
        url: `${config.API_URL}/JKD-420-4G-ONENET/service/vibInterval/`,
        name: "JKD-420-4G-ONENET震动报警触发最小间隔",
        post: async function (deviceNumber, data) {
            return await http.post(this.url + deviceNumber, data);
        },
    },
}
